import { MatchModelBase, SportMatchModel } from '@nf/types/odds';
import { TimeMachineContent } from './components/time-machine-content';
import { TimeMachineSlider } from './components/time-machine-slider';
import { TimeMachineButton } from './components/time-machine-button';
import { TimeMachineProvider } from './context/time-machine-context';
import { useAccountInfo } from '@/hooks/query/account';
import clsx from 'clsx';
import { TimeMachineHeader } from './components/time-machine-header';
import { useState } from 'react';
import { QuestionIcon } from '@/components/icons/svg-icons';
import { useTranslations } from 'next-intl';
import { useFilterSabaString } from '@/hooks/query/use-saba-filter';
import { timeMachineStyles } from './time-machine.style';
import { cx } from 'styled-system/css';

interface TimeMachineProps {
	match: SportMatchModel | null;
	showHeader?: boolean;
}

export const TimeMachine = ({ match, showHeader }: TimeMachineProps) => {
	const [isOpen, setIsOpen] = useState(showHeader ? false : true);

	if (!match) return null;

	const children = (
		<TimeMachineBetTypeContent
			matchModel={match}
			isOpen={isOpen}
			setIsOpen={setIsOpen}
		/>
	);

	return showHeader ? (
		<TimeMachineHeader isOpen={isOpen} setIsOpen={setIsOpen}>
			{children}
		</TimeMachineHeader>
	) : children;
}


interface TimeMachineBetTypeContentProps {
	matchModel: SportMatchModel;
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
}

const TimeMachineBetTypeContent = ({ matchModel, isOpen, setIsOpen }: TimeMachineBetTypeContentProps) => {
	const { user } = useAccountInfo();
	const tmIntervalTime = user?.TMINR ?? 6;

	return (
		<div className="bettype__content">
			<TimeMachineQuestionTip />
			<TimeMachineProvider
				matchModel={matchModel as MatchModelBase}
				tmIntervalTime={tmIntervalTime}
			>
				<TimeMachineContent
					matchModel={matchModel as SportMatchModel}
					isOpen={isOpen}
				/>
				<TimeMachineSlider
					isOpen={isOpen}
					setIsOpen={setIsOpen}
				/>
				<TimeMachineButton />
			</TimeMachineProvider>
		</div>
	);
}

const TimeMachineQuestionTip = () => {
	const [isTipOpen, setIsTipOpen] = useState(false);
	const t = useTranslations('General');
	const { filterSabaString } = useFilterSabaString();
	const tipContent = filterSabaString(t('lbl_SabaTM_info'));

	return (
		<div className={cx('bettype__question', timeMachineStyles.question)} data-open={isTipOpen}>
			<button
				className="btn btn--icon"
				onClick={() => setIsTipOpen(!isTipOpen)}
			>
				<QuestionIcon />
			</button>
			<div className={clsx('tip', 'tip--detail tip--right')} data-open={isTipOpen} >
				<div className="scrollbar scrollbar--tip">
					<div className="tip__content">
						{tipContent}
					</div>
				</div>
			</div>
		</div>
	);
};




